import {action, makeObservable, observable} from "mobx";
import benefits from "../api/controllers/Benefits";
import {Benefit, BenefitPayload} from "../models/Benefit";

class Store {
  @observable public benefitId?: string;
  @observable public benefit?: Benefit;

  constructor() {
    makeObservable(this);
  }

  @action public getBenefit = async () => {
    const data = await benefits.getById(this.benefitId)
    this.setBenefit(data)
  }

  @action public setBenefitId = (benefitId: string) => {
    this.benefitId = benefitId;
  }

  @action public setBenefit = (benefit?: Benefit) => {
    this.benefit = benefit;
  }

  @action public putBenefit = async (benefit: Benefit) => {
    const data = await benefits.putBenefit(this.benefitId, benefit);

    this.setBenefit(data);
  }

  @action public addBenefit = async (benefit: BenefitPayload) => {
    const data = await benefits.addBenefit(benefit);

    this.setBenefit(data);
    return data;
  }

  @action public deleteBenefit = async (benefitId: string)=> {
    await benefits.deleteBenefit(benefitId);

    this.setBenefit(undefined);
    return;
  }
}

const BenefitManagementStore = new Store();

export default BenefitManagementStore;


